// Holds the messages of the currently loaded locale so non-React code
// (helpers, redux thunks) can look up translations without importing every
// locale bundle. Populated by I18nProvider once the locale chunk loads.
let activeMessages: Record<string, string> = {}

export const setActiveMessages = (messages: Record<string, string>) => {
  activeMessages = messages
}

export const getActiveMessages = (): Record<string, string> => activeMessages
